import React from 'react';
import { useCheckWinResults } from 'features/tickets/hooks';

export interface UseEventResultsHandlerOptions {
  /** Effective results to display (from run or current_result). */
  results: Record<string, unknown> | null;
  /** Whether results are from a delayed upsert (pending timer). */
  isDelayed?: boolean;
}

export interface UseEventResultsHandlerReturn {
  results: Record<string, unknown> | null;
  isDelayed: boolean;
  winResults: unknown;
  checkWins: (params?: { event_id?: string | number }) => void;
  checksLoading: boolean;
}

/**
 * Encapsulates results display state and win-check orchestration.
 * Timer cancellation on schedule switch is handled by EventViewer calling
 * cancelTimersForSchedule(prevScheduleId) (Stage 3).
 */
export function useEventResultsHandler(
  scheduleId: string | number | null | undefined,
  eventId: string | number | null | undefined,
  options: UseEventResultsHandlerOptions
): UseEventResultsHandlerReturn {
  const { results, isDelayed = false } = options;
  const { win_results: winResults, loading: checksLoading, checkWinResults } = useCheckWinResults();

  const checkWins = React.useCallback(
    (params?: { event_id?: string | number }) => {
      const id = params?.event_id ?? eventId;
      if (id != null) checkWinResults({ event_id: id });
    },
    [eventId, checkWinResults]
  );

  return {
    results,
    isDelayed,
    winResults,
    checkWins,
    checksLoading,
  };
}
